import FingerprintJS from '@fingerprintjs/fingerprintjs'

let cachedUuid = null

export async function getUuid() {
  if (cachedUuid) return cachedUuid

  const stored = localStorage.getItem('uuid')
  if (stored) {
    cachedUuid = stored
    return cachedUuid
  }

  const fp = await FingerprintJS.load()
  const result = await fp.get()
  cachedUuid = result.visitorId
  localStorage.setItem('uuid', cachedUuid)
  return cachedUuid
}
